import React, { useEffect } from "react";

import SideBar from "../../components/documents/Sidebar";
import { useLocation } from "react-router-dom";
import { Outlet, useNavigate } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import { resetCard } from "../../redux/slices/CardSlices";
import { connect, useDispatch } from "react-redux";
import { resetTab } from "../../redux/slices/TabSlices";
import { Toaster } from "react-hot-toast";
import { getStatusQuoAutditTrail } from "../../services/auditTrails";
import { getUserIdFromLocalStorage } from "../../utils/Utilities";
import { getUpdatedData } from "../../redux/slices/DocumentsSlice";

const DocumentsPage = ({ resetCard, resetTab }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  useEffect(() => {
    resetCard();
    if (!localStorage.getItem("token") && !localStorage.getItem("auth")) {
      navigate("/");
    }
  }, [navigate]);
  const fetchAuditTrail = async () => {
    const result = await getStatusQuoAutditTrail(currentConsultantId);
    if (result?.success) {
      dispatch(getUpdatedData(result?.payLoad));
    } else {
      dispatch(getUpdatedData([]));
    }
  };
  useEffect(() => {
    resetCard();
    resetTab();
    fetchAuditTrail();
  }, [location.pathname]);

  return (
    <>
      <Toaster />
      <Box className="family-tree-main-container">
        <Grid container spacing={5} className="balance-of-assets ">
          <Grid item xl={1} lg={1} sm={12} xs={12} />
          <Grid item xl={2} lg={2} sm={12} xs={12} className="side-bar">
            <SideBar />
          </Grid>
          <Grid
            item
            xl={9}
            lg={9}
            sm={12}
            xs={12}
            sx={{
              // overflow: "hidden !important",
              height: "calc(100vh - 75px) !important",
            
            }}
            className="documents-right-col"
          >
            <Outlet context={[location]} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    resetCard: () => dispatch(resetCard()),
    resetTab: () => dispatch(resetTab()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsPage);
